import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Divider, Grid, List } from '@mui/material'
import http from 'axios'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import ProductGrid from './ProductGrid'
import ProductList from './ProductList'

function Products({ classes, noProduct, products }) {
	const navigate = useNavigate()
	const shop = useSelector(state => state.shop)
	const prodDisplayMode = shop.profiles.ueby_products_list_display_mode

	const gotoProduct = (product) => {
		navigate(`/shop/prod/${product.url_name}-${product.item_id}`)
	}

	return (<React.Fragment>
		{products && <Grid container spacing={1} className={classes.productsList}>
			{products.length == 0 && <Grid item xs={12}>
				<p className={classes.pageSubTitle}>{noProduct || 'Nessun prodotto presente in questa categoria'}</p>
			</Grid>}
			{prodDisplayMode == 1 && products.map((product, p) => (<ProductGrid
				key={p}
				product={product}
				gotoProduct={gotoProduct}
			/>))}
			{prodDisplayMode == 2 && <List style={{ width: '100%' }}>
				{products.map((product, p) => (<React.Fragment key={p}>
					<ProductList
						product={product}
						gotoProduct={gotoProduct}
					/>
					{p < products.length - 1 && <Divider />}
				</React.Fragment>))}
			</List>}
		</Grid>}
	</React.Fragment>)
}

export default withStyles(style)(Products)
